@if (line && !line.decisions) {
  <p class="err">Cycle de vie illisible : les décisions de cette ligne ne peuvent pas être lues.</p>
} @else if (line && !tables.length) {
  <p class="empty">Aucune décision sur cette ligne.</p>
} @else {
  @for (t of tables; track t.key) {
    <h4 class="tt">{{ t.title }}</h4>
    <table class="dec" [attr.data-kind]="t.key">
      <thead>
        <tr>
          @for (h of t.heads; track $index) {
            <th>{{ h }}</th>
          }
          <th>État</th>
          <th class="act"><span class="sr">Actions</span></th>
        </tr>
      </thead>
      <tbody>
        @for (r of t.rows; track r.ref.id) {
          <tr class="row" [class.cancelled]="r.cancelNote !== null" [attr.data-id]="r.ref.id">
            @for (c of r.cells; track $index) {
              <td [attr.title]="c.title || null" [class.day]="c.day">
                @if (c.dot) {<span class="dot" [style.background]="c.dot"></span>}{{ c.text }}
                @if (c.sub) {<small>{{ c.sub }}</small>}
              </td>
            }
            <td class="state">
              {{ r.state }}
              @if (r.replaces !== null) {<small class="replaces">remplace n° {{ r.replaces }}</small>}
            </td>
            <td class="act">
              @if (r.canModify) {
                <button mat-stroked-button type="button" class="modify" (click)="modify.emit(r.ref)">Modifier</button>
              }
              @if (r.canCancel) {
                <button mat-stroked-button type="button" class="cancel" (click)="cancel.emit(r.ref)">Annuler</button>
              }
            </td>
          </tr>
          @if (r.cancelNote) {
            <tr class="note">
              <td [attr.colspan]="t.heads.length + 2">{{ r.cancelNote }}</td>
            </tr>
          }
        }
      </tbody>
    </table>
  }
}
